module.exports = __webpack_public_path__ + "static/img/4.134cc44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/4.png
// module id = cRiB
// module chunks = 0